import { t } from 'i18next'
import { Dropdown } from 'primereact/dropdown'
import { DropdownItem } from '../../../../model/dropdownItem.model'

export const RoundingTypeDropdown = (props: {
  activeValue: number | undefined
  setActive: (e: number) => void
  fieldIsDisabled?: boolean
}) => {
  const roundingTypes: DropdownItem[] = [
    {
      label: t<string>('grade_module.grade.rounding_type.no_rounding'),
      value: 9,
    },
    { label: t<string>('grade_module.grade.rounding_type.10'), value: 10 },
    { label: t<string>('grade_module.grade.rounding_type.11'), value: 11 },
    { label: t<string>('grade_module.grade.rounding_type.7'), value: 7 },
    { label: t<string>('grade_module.grade.rounding_type.8'), value: 8 },
    { label: t<string>('grade_module.grade.rounding_type.3'), value: 3 },
    { label: t<string>('grade_module.grade.rounding_type.4'), value: 4 },
    { label: t<string>('grade_module.grade.rounding_type.1'), value: 1 },
    { label: t<string>('grade_module.grade.rounding_type.2'), value: 2 },
    // jausc: 0.3 up and down is currently not implemented on the backend
    // {label: t<string>('grade_module.grade.rounding_type.5'), value: 5},
    // {label: t<string>('grade_module.grade.rounding_type.6'), value: 6},
  ]

  return (
    <Dropdown
      options={roundingTypes}
      value={props.activeValue}
      defaultValue={9}
      placeholder={t<string>('grade_module.grade.rounding_type.choose')}
      className={'w-full'}
      onChange={(e) => props.setActive(e.value)}
      disabled={props.fieldIsDisabled}
    />
  )
}